import * as React from 'react'
export const SvgIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props}></svg>
)
export default SvgIcon
